const SANS_SERIF = 'sans-serif';
const fonts = {
    noto: ['Noto Sans KR', SANS_SERIF],
    notoSansKR: "Noto Sans KR",
    helveticaNeue: ['Helvetica Neue', SANS_SERIF],
    roboto: ['Roboto', SANS_SERIF]
};
export default fonts;
//# sourceMappingURL=fonts.js.map